import type { Result as GetSignedUploadResult, Params } from '@api/routes/asset/get-upload-url/params';
import type { ApiResponse } from '@api/types';
import { GET_ASSET_CLIENT_UPLOAD_URL } from '@api/constants/routes';

import { API_HOST } from 'src/utils/api';

export async function getSignedUploadUrl(params: Params): Promise<ApiResponse<GetSignedUploadResult>> {
  const response = await fetch(`${API_HOST}${GET_ASSET_CLIENT_UPLOAD_URL}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
    credentials: 'include',
  });

  const result = (await response.json()) as ApiResponse<GetSignedUploadResult>;

  return result;
}

export function uploadMedia(
  url: string,
  file: File,
  onProgress: (progress: number) => void
): Promise<ApiResponse<string>> {
  return new Promise(resolve => {
    const xhr = new XMLHttpRequest();
    xhr.open('PUT', url);

    xhr.setRequestHeader('Content-Type', file.type);
    xhr.setRequestHeader('Cache-Control', 'no-cache');

    xhr.upload.onprogress = event => {
      if (event.lengthComputable) {
        const percentComplete = (event.loaded / event.total) * 100;
        onProgress(percentComplete);
      }
    };

    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve({ success: true, data: 'OK' });
      } else {
        resolve({ success: false, error: { error: new Error(`Upload failed with status ${xhr.status}`) } });
      }
    };

    xhr.onerror = () => {
      resolve({ success: false, error: { error: new Error('Network error during upload') } });
    };

    xhr.send(file);
  });
}